/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_SCHEDULED_MESSAGE,
  GET_SCHEDULED_MESSAGE_SUCCESS,
  GET_SCHEDULED_MESSAGE_ERROR,
  UPDATE_SCHEDULED_MESSAGE,
  UPDATE_SCHEDULED_MESSAGE_SUCCESS,
  UPDATE_SCHEDULED_MESSAGE_ERROR,
  SOCKET_SCHEDULED_MESSAGE_MANUALLY_SENT,
  SOCKET_SCHEDULED_BIRTHDAY_MESSAGE_SENT,
} from 'src/actions/scheduledMessagesDetailsActions';

const initialState = {
  scheduledMessage: null,
  // currentNavigationTab: 'details',
  loading: false,
};

const scheduledMessagesDetailsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SCHEDULED_MESSAGE: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_SCHEDULED_MESSAGE_SUCCESS: {
      return produce(state, (draft) => {
        draft.scheduledMessage = payload;
        draft.loading = false;
      });
    }

    case GET_SCHEDULED_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case UPDATE_SCHEDULED_MESSAGE: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_SCHEDULED_MESSAGE_SUCCESS: {
      return produce(state, (draft) => {
        draft.scheduledMessage = payload;
        draft.loading = false;
      });
    }

    case UPDATE_SCHEDULED_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SOCKET_SCHEDULED_BIRTHDAY_MESSAGE_SENT:
    case SOCKET_SCHEDULED_MESSAGE_MANUALLY_SENT: {
      return produce(state, (draft) => {
        if (payload?.id === state?.scheduledMessage?.id) {
          draft.scheduledMessage.isSending = payload?.isSending;
          draft.scheduledMessage.isProbablySent = !!(!payload?.isSending && state?.scheduledMessage?.isSending);
        }
      });
    }

    default: {
      return state;
    }
  }
};

export default scheduledMessagesDetailsReducer;
